import { Injectable } from '@angular/core';
import { AuthLinksService } from './auth-links.service';
import { InAppBrowserService } from './in-app-browser.service';
import { ToastNotificationService } from './toast-notification/toast-notification.service';
import { ToastNotificationComponent } from '../shared/toast-notification/toast-notification.component';
import { RedirectLoginService } from './redirect-login/redirect-login.service';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InAppBrowserAuthService {
  private urlChange$: null | Subscription = null;
  private browserClose$: null | Subscription = null;


  public constructor(
    private authLinksService: AuthLinksService,
    private browserService: InAppBrowserService,
    private toastService: ToastNotificationService,
    private redirectLoginService: RedirectLoginService,
  ) {}

  public openInAppBrowser(): void {
    this.browserService.open(this.authLinksService.bcasClientLoginUrl);

    if(!this.browserService.networkConnected) {
      this.browserService.close();
      this.toastService.addNotification({
        title: 'toastNotifications.headers.error',
        message: 'toastNotifications.messages.browserLoginLoadError',
        type: 'warning',
        component: ToastNotificationComponent
      });
      return;
    }

    this.urlChange$ = this.browserService.onUrlChange().subscribe((navUrl) => {
      if (navUrl.startsWith(this.authLinksService.clientRedirectUri) || navUrl.startsWith(this.authLinksService.consultRedirectUri)) {
        this.handleLoginRedirect(navUrl);
        this.browserService.close();
        this.unsubBrowser();
      }
    });

    this.browserClose$ = this.browserService.onBrowserClose().subscribe(() => {
      this.unsubBrowser();
    });
  }

  private handleLoginRedirect(navUrl: string): void {
    const pathWithToken = navUrl.replace(this.authLinksService.clientRedirectUri , '').replace('?', '');
    const bcasUrlTokens = pathWithToken.split('&');

    for (const parameter of bcasUrlTokens) {
      const [key, value] = parameter.split('=');

      if(key === 'code') {
        this.redirectLoginService.assignKeyAndNavigate(value);
      }
    }
  }

  private unsubBrowser(): void {
    this.browserClose$?.unsubscribe();
    this.urlChange$?.unsubscribe();
    this.browserClose$ = null;
    this.urlChange$ = null;
  }
}
